module.exports = __webpack_public_path__ + "assets/img/goOnline.c5d3fb86.png";